import _regeneratorRuntime from "/opt/build/repo/website/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { composeSubscriber } from '../module';
import { selectEffectSubscriberProps } from './effectSelectors';
import { effectActionCreators } from './effectState';
export var startEffect = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(effect, payload, state) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = effect.effectKind;
            _context.next = _context.t0 === 'effect' ? 3 : _context.t0 === 'payloadlessEffect' ? 4 : _context.t0 === 'statefulEffect' ? 5 : _context.t0 === 'statefulPayloadlessEffect' ? 6 : 7;
            break;

          case 3:
            return _context.abrupt("return", effect.run(payload.effect));

          case 4:
            return _context.abrupt("return", effect.run());

          case 5:
            return _context.abrupt("return", effect.run(effect.selector(state), payload.effect));

          case 6:
            return _context.abrupt("return", effect.run(effect.selector(state)));

          case 7:
            return _context.abrupt("return", Promise.resolve());

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function startEffect(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export function composeEffectHandler(effects) {
  return function (queuedEffects, state) {
    effectActionCreators.removeFromQueue(queuedEffects.toArray());
    queuedEffects.forEach(function (effectPayload) {
      var effect = effects.get(effectPayload.effectType);
      startEffect(effect, effectPayload, state).then(effectPayload.resolve).catch(effectPayload.reject);
    });
  };
}
export function effectSubscriber(effects) {
  var effectHandler = composeEffectHandler(effects);
  return composeSubscriber({
    selector: selectEffectSubscriberProps,
    onChange: function onChange(_ref2) {
      var queuedEffects = _ref2.queuedEffects,
          state = _ref2.state;

      if (queuedEffects.size < 1) {
        return;
      }

      effectHandler(queuedEffects, state);
    }
  });
}